import { StanButton } from '@/components';

interface AdyenPaymentCardProps {
    isConnected: boolean;
    loading: boolean;
    showAddPayPal: boolean;
    onManage: () => void;
    onConnect: () => void;
    onAddPayPal: () => void;
}

export const AdyenPaymentCard = ({
    isConnected,
    loading,
    showAddPayPal,
    onManage,
    onConnect,
    onAddPayPal,
}: AdyenPaymentCardProps) => {
    return (
        <div className='flex w-full flex-col gap-2'>
            <div className='bg-bg-subtle rounded-lg p-4'>
                {isConnected ? (
                    <StanButton
                        name='adyen-account-manage-button'
                        variant='outline'
                        size='sm'
                        loading={loading}
                        onClick={onManage}
                        className='w-full'
                    >
                        Manage Your Adyen Account
                    </StanButton>
                ) : (
                    <StanButton
                        name='adyen-account-register-button'
                        size='sm'
                        loading={loading}
                        onClick={onConnect}
                        className='w-full'
                    >
                        Connect Your Adyen Account
                    </StanButton>
                )}
            </div>

            {showAddPayPal && (
                <button
                    className='text-body-sm text-brand-main ml-auto w-fit cursor-pointer text-right font-medium'
                    onClick={onAddPayPal}
                >
                    + Add PayPal
                </button>
            )}
        </div>
    );
};
